import { ref, computed } from 'vue';
import store from '@/store/index.js';

export function usePermissionFunction() {

  //防止關聯的父曾在權限為0時，子權限還是100
  const switchOrgItem = () => {
    if(!store.state.user_data.permission_list){
      return;
    }
    const creator = store.state.user_data.permission_list?.creatorManagement;
    if (creator?.editCreatorInformation?.permission !== 100) {
      if (creator?.editBasicInfo) creator.editBasicInfo.permission = 0;
      if (creator?.addOrEditCreatorTags) creator.addOrEditCreatorTags.permission = 0;
      if (creator?.editStorefrontPermissions) creator.editStorefrontPermissions.permission = 0;
      if (creator?.editChatPermissions) creator.editChatPermissions.permission = 0;
      if (creator?.addOrEditContentTag) creator.addOrEditContentTag.permission = 0;
      if (creator?.importSocialContent) creator.importSocialContent.permission = 0;
    }
  
    const recruitment = store.state.user_data.permission_list?.recruitment;
    //spec-------------------------------------------------------------
    if( !store.state.user_data?.merchant_account?.is_enable_ambassador_program) {
      recruitment.manageApplications.permission = 50;
      recruitment.manageCandidates.permission = 50;
    }
    //-------------------------------------------------------------
    if (recruitment?.manageApplications?.permission !== 100) {
      if (recruitment?.createApplications) recruitment.createApplications.permission = 0;
      if (recruitment?.editApplicationSettings) recruitment.editApplicationSettings.permission = 0;
      if (recruitment?.editEmailTemplates) recruitment.editEmailTemplates.permission = 0;
    }
  
    if (recruitment?.manageCandidates?.permission !== 100) {
      if (recruitment?.approveOrRejectApplicants) recruitment.approveOrRejectApplicants.permission = 0;
      if (recruitment?.viewApplicantDetails) recruitment.viewApplicantDetails.permission = 0;
    }
    
    const message = store.state.user_data.permission_list?.messagesAndAnnouncements;
    //spec-------------------------------------------------------------
    if( !store.state.user_data?.merchant_account?.is_enable_chatroom) {
      message.manageMessaging.permission=50;
    }

    if( !store.state.user_data?.merchant_account?.is_enable_announcement) {
      message.manageAnnouncements.permission=50;
    }
    //-------------------------------------------------------------
    
    if (message?.manageMessaging?.permission !== 100) {
      if (message?.chatWithCreator) message.chatWithCreator.permission = 0;
      if (message?.editWelcomeMessage) message.editWelcomeMessage.permission = 0;
      if (message?.sendOnlyOrDisableChat) message.sendOnlyOrDisableChat.permission = 0;
    }
    if (message?.manageAnnouncements?.permission !== 100) {
      if (message?.draftAndScheduleAndPublishAnnouncements) message.draftAndScheduleAndPublishAnnouncements.permission = 0;
      if (message?.disableOrDeletePublishedAnnouncements) message.disableOrDeletePublishedAnnouncements.permission = 0;
    }
  
    const reports = store.state.user_data.permission_list?.reports;
    if (reports?.downloadReports?.permission !== 100) {
      if (reports?.downloadCreatorPerformanceByDay) reports.downloadCreatorPerformanceByDay.permission = 0;
      if (reports?.downloadPerformanceOverview) reports.downloadPerformanceOverview.permission = 0;
      if (reports?.downloadProductPerformance) reports.downloadProductPerformance.permission = 0;
      if (reports?.downloadCollectionsPerformance) reports.downloadCollectionsPerformance.permission = 0;
      if (reports?.downloadPostPerformance) reports.downloadPostPerformance.permission = 0;
      if (reports?.downloadBrandContentPerformance) reports.downloadBrandContentPerformance.permission = 0;
    }
  
    const workspace = store.state.user_data.permission_list?.settingWorkspace;
    if (workspace?.teamSettings?.permission !== 100) {
      if (workspace?.inviteTeammates) workspace.inviteTeammates.permission = 0;
      if (workspace?.assignRoleAndCompanyOrTeamToTeammates) workspace.assignRoleAndCompanyOrTeamToTeammates.permission = 0;
      if (workspace?.manageTeammates) workspace.manageTeammates.permission = 0;
      if (workspace?.createAndEditAndManageCustomCompanyOrTeam) workspace.createAndEditAndManageCustomCompanyOrTeam.permission = 0;
      if (workspace?.editRolePermissions) workspace.editRolePermissions.permission = 0;
      if (workspace?.createAndEditAndManageCustomRoles) workspace.createAndEditAndManageCustomRoles.permission = 0;
    }
  
    const integration = store.state.user_data.permission_list?.settingIntegrations;
    if (integration?.integrations?.permission !== 100) {
      if (integration?.domainSettings) integration.domainSettings.permission = 0;
      if (integration?.scriptManagerSettings) integration.scriptManagerSettings.permission = 0;
    }
    if (integration?.privacySettings?.permission === 0) {
      if (integration?.addOrEditTermsAndConditions) integration.addOrEditTermsAndConditions.permission = 0;
      if (integration?.addOrEditPrivacyPolicy) integration.addOrEditPrivacyPolicy.permission = 0;
    }
  
    // console.log('store.state.user_data.permission_list', store.state.user_data.permission_list);
  };
  

  return {
    switchOrgItem
  };
}
